import {
  GET_SITE_LICENCE,
  GET_SETTINGS_ERROR,
  SITE_SETTINGS_LOADING,
  SET_SITE_LICENCE,
  GET_DECRYPTED_LICENCE,
  GET_AUTH_ALERT,
  SET_AUTH_ALERT,
  GET_PUBLIC_STATUS,
} from '../actions/types'

const initialState = {
  siteLicence: null,
  decrypted: null,
  loading: true,
  alert: null,
  publicAccess: undefined,
  errors:  null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SITE_SETTINGS_LOADING:
      return {
        ...state,
        loading: true,
        errors:null,
      }
    case GET_SITE_LICENCE:
      return {
        ...state,
        siteLicence: action.payload,
        loading: false,
        errors:null,
      }
    case SET_SITE_LICENCE:
      return {
        ...state,
        siteLicence: action.payload,
        loading: false,
        errors:null,
      }
    case GET_DECRYPTED_LICENCE:
      return {
        ...state,
        decrypted: action.payload,
        loading: false,
        errors:null,
      }
    case GET_PUBLIC_STATUS:
      return {
        ...state,
        publicAccess: action.payload,
        loading: false,
        errors:null,
      }
    case GET_AUTH_ALERT:
    case SET_AUTH_ALERT:
      return {
        ...state,
        alert: action.payload,
        loading: false,
        errors:null,
      }
    case GET_SETTINGS_ERROR : 
      return  {
        ...state,
        loading: false,
        errors: action.payload,
      }
    default:
      return state
  }
}
